export default __webpack_public_path__ + "static/media/Arm-straps of the Faceless Sphinx.fd46914f.jpg";